<div>
  <div class="info-strip clearfix">
    <div class="info-strip-right">
      <div class="return" *ngIf="showimageviewer">
        <span class="plus" tabindex="0" (click)="toggleReturn()">+</span>
        <div class="return-hidden" [ngStyle]="{'display': screenWidth > 1000 ? 'block' : (collapseReturn) ? 'block' : 'none'}">
          <input placeholder="Book" [(ngModel)]="returnbook" />
          <input placeholder="Page" [(ngModel)]="returnpage" />
        </div>
        <button type="button" (click)="returnToStart(returnbook,returnpage)">
          Return<span class="smaller-hidden"> to start</span>
        </button>
      </div>
      <div class="book-page-here" *ngIf="showimageviewer && !isPlanBook">
        <i tabindex="0" class="fa fa-caret-left" (click)="getPrevDocument($event)" title="Go to Previous Document"></i>
        <p>Book/Page {{docbeginbook}}/{{docbeginpage}}</p>
        <i tabindex="0" class="fa fa-caret-right" (click)="getNextDocument($event)" title="Go to Next Document"></i>
      </div>
      <div class="book-page-here" *ngIf="showimageviewer && isPlanBook">
        <i tabindex="0" class="fa fa-caret-left" (click)="getPrevDocument($event)"></i>
        <p>Plan Book/Page {{docbeginbook}}/{{docbeginpage}}</p>
        <i tabindex="0" class="fa fa-caret-right" (click)="getNextDocument($event)"></i>
      </div>

      <div id="list-two" class="basket" *ngIf="showimageviewer" (drop)="drop(record.docDetail.docType,docbeginbook,docbeginpage,currentIndex)" (dragover)="allowDrop($event)">
        <app-doc-basket [docId]="record.docDetail.docID" [doctype]="record.docDetail.docType" [pagecount]="record.docDetail.pageCount" [docbeginbook]="docbeginbook" [docbeginpage]="docbeginpage" [currentindex]="currentIndex" (loaderEvent)="receiveLoader($event)"></app-doc-basket>
      </div>
      <div class="book-page-go" *ngIf="showimageviewer">
        <span class="plus" tabindex="0" (click)="toggleGo()">+</span>
        <form #form="ngForm" (ngSubmit)="searchDocument(sBook,sPage)">
          <div class="book-page-go-hidden" [ngStyle]="{'display': screenWidth > 1000 ? 'block' : (collapseGo) ? 'block' : 'none'}">
            <input placeholder="Book" [(ngModel)]="sBook" name="sBook" />
            <input placeholder="Page" [(ngModel)]="sPage" name="sPage"/>
          </div>
          <button type="submit">Go</button>
        </form>
      </div>
      <div class="book-page-go" *ngIf="showimageviewer">
        <span class="plus" tabindex="1" (click)="toggleGo()">+</span>
        <form #form2="ngForm" (ngSubmit)="searchPlan(sPlanBook,sPlanPage)">
          <div class="book-page-go-hidden" [ngStyle]="{'display': screenWidth > 1000 ? 'block' : (collapseGo) ? 'block' : 'none'}">
            <input placeholder="Plan Bk" [(ngModel)]="sPlanBook" name="sPlanBook"/>
            <input placeholder="Plan Pg" [(ngModel)]="sPlanPage" name="sPlanPage"/>
          </div>
          <button type="submit">Go</button>
        </form>
      </div>

    </div>
  </div>
  <div class="image-page large" *ngIf="isImgVwVisible">
    <div class="image-page-contents">
      <button class="see-image-button" (click)="showimgviewer()">
        <p>CLICK TO VIEW IMAGE</p>
      </button>
      <img src="images/picture-icon.png" />
    </div>
  </div>
  <div *ngIf="showimageviewer" class="image-page small">
    <div *ngIf="showPaging" class="image-paging">
      <i tabindex="0" class="fa fa-angle-double-left" (click)="isFirstPage || getFirstPg($event)" [ngStyle]="{'color':isFirstPage ? 'grey' : '#21495C' }" title="First Page"></i>&nbsp;
      <i class="fa fa-angle-left" (click)="isFirstPage || getPrevPg($event)" [ngStyle]="{'color':isFirstPage ? 'grey' : '#21495C' }" title="Previous Page"></i>&nbsp;
      <p><span>pg </span>{{currentIndex}} of {{pageCount}}</p>&nbsp;
      <i class="fa fa-angle-right" (click)="isLastPage || getNextPg($event)" [ngStyle]="{'color':isLastPage ? 'grey' : '#21495C' }" title="Next Page"></i>&nbsp;
      <i class="fa fa-angle-double-right" (click)="isLastPage || getLastPg($event)" [ngStyle]="{'color':isLastPage ? 'grey' : '#21495C' }" title="Last Page"></i>
    </div>
    <div *ngIf="isLoadingImage; else showimage">
      <div class="imgpanel">
        Loading Image ...
      </div>
    </div>
    <ng-template #showimage>
      <div class="imgpanel" draggable="true" *ngIf="currentImage.length!=0 ; else showMsg"
           (dragstart)="drag($event)">
        <!--<ngx-extended-pdf-viewer [src]="'/assets/DraftContract.pdf'"
                           [height]="'auto'" [textLayer]="true" [showHandToolButton]="true">-->
        <!-- you can also use %, px and vh, or omit the attribute altogether -->
        <!--</ngx-extended-pdf-viewer>-->
        <ngx-extended-pdf-viewer #pdfViewer [base64Src]="blobImage"
                                 [height]="'auto'" [textLayer]="false"
                                 [zoom]="'auto'"
                                [showToolbar]="true"
                                [showSidebarButton]="false"
                                [showFindButton]="false"
                                [showPagingButtons]="false"
                                [showDrawEditor]="false"
                                [showStampEditor]="false"
                                [showTextEditor]="false"
                                [showZoomButtons]="always-visible"
                                [showSelectScale]="always-visible"
                                [showPresentationModeButton]="always-visible"
                                [showOpenFileButton]="false"
                                [showPrintButton]="false"
                                [showDownloadButton]="false"
                                [showSecondaryToolbarButton]="false"
                                [showRotateButton]="true"
                                [showRotateCwButton]="always-visible"
                                [showRotateCcwButton]="always-visible"
                                [showHighlightEditor]="false"
                                [showHandToolButton]="false"
                                [showScrollingButton]="true"
                                [showSpreadButton]="false"
                                [enablePinchOnMobile]="true"
                                 [useBrowserLocale]="true"
                                 [showPropertiesButton]="false">
        </ngx-extended-pdf-viewer>
        <!--<app-image-viewer [images]="currentImage"
                          [idContainer]="'idOnHTML'"
                          [loadOnInit]="true"
                          [showPDFOnlyOption]="false"
                          [download]="allowDownload"
                          [fullscreen]="false"
                          (onNext)="getNextPg($event)"
                          (onPrevious)="getPrevPg($event)"></app-image-viewer>-->
      </div>
      <ng-template #showMsg>
        <div class="noImg">Image in process (Note: plans or large documents may take a bit longer to load)</div>
      </ng-template>
    </ng-template>
  </div>

  <dx-popup [width]="350"
            [height]="150"
            [showTitle]="true"
            title="Information"
            [dragEnabled]="false"
            [closeOnOutsideClick]="true"
            [(visible)]="popupVisible">
    <div>
      <p>
        {{Message}}
      </p>

    </div>
  </dx-popup>
  <!--<div class="uploader-status" *ngIf="showLoader">
    <mat-spinner diameter="50" strokeWidth="2" style="margin:0 auto;"></mat-spinner>
  </div>-->
</div>
